import dayjs from 'dayjs';

/**
 * Function convert transaction api response to view transaction
 * Example result:
 * [
 *    {
 *      month: '8',
 *      year: '2022',
 *      transactions: []
 *    },
 *    {
 *      month: '7',
 *      year: '2022'
 *      transactions: []
 *    }
 * ]
 *
 * @param {*} transactions - the transaction api response
 * @returns {*} - formatted transactions
 */
export const formatTransaction = (transactions) => {
  const monthYearTransactions = [];
  transactions.forEach((transaction) => {
    const { createdAt } = transaction;
    const date = dayjs(createdAt);
    const month = date.format('MMMM');
    const year = date.format('YYYY');

    const preMonthTransactions = monthYearTransactions[monthYearTransactions.length - 1];

    if (preMonthTransactions && preMonthTransactions.month === month) {
      preMonthTransactions.transactions.push(transaction);
    } else {
      monthYearTransactions.push({
        month,
        year,
        transactions: [transaction]
      });
    }
  });

  return monthYearTransactions;
};

export const getOptionName = (key, options) => options.find((option) => option.key === key)?.name;
